<template>
  <div id="number-card">
    <div class="main">
      <span class="head-img">
       <img :src="headImg" alt="">
      </span>
      <div class="text">
        <label class="number" :style="numberStyle">{{ num }}</label>
        <label class="explain">{{ exp }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/font_3063249_hpan52807f/iconfont.css'
import ek from '../assets/img/ek.png'
import fk from '../assets/img/fk.png'
import nk from '../assets/img/nk.png'
import pfk from '../assets/img/pfk.png'
import zjk from '../assets/img/zjk.png'
import zwb from '../assets/img/zwb.png'
export default {
  name: 'MyChart',
  data() {
    return {
      roleName: this.role,
      wh: this.w,
      num: this.number,
      exp: this.explain,
      numberColor: 'purple',
      headImg: 'iconfont icon-yiyuan',
      numberStyle: 'color: purple;',
      cardData: {
        yiyuan: {
          headImg: ek,
          numberColor: 'rgba(0, 0, 0, .5)',
        },
        yiyuanjieshaobeifen: {
          headImg: fk,
          numberColor: 'rgba(0, 0, 0, .5)'
        },
        yiyuan1: {
          headImg: nk,
          numberColor: 'rgba(0, 0, 0, .5)'
        },
        yiyuan2: {
          headImg: pfk,
          numberColor: 'rgba(0, 0, 0, .5)'
        },
        yiyuanzixun: {
          headImg: zjk,
          numberColor: 'rgba(0, 0, 0, .5)'
        },
        yiyuanguanjia_yinshianpai: {
          headImg: zwb,
          numberColor: 'rgba(0, 0, 0, .5)'
        }
      },
      // cardData: {
      //   yiyuan: {
      //     headImg: 'iconfont icon-yiyuan',
      //     numberColor: '#496DC3'
      //   },
      //   yiyuanjieshaobeifen: {
      //     headImg: 'iconfont icon-yiyuanjieshaobeifen',
      //     numberColor: '#3C4C71'
      //   },
      //   yiyuan1: {
      //     headImg: 'iconfont icon-yiyuan1',
      //     numberColor: '#3C4C71'
      //   },
      //   yiyuan2: {
      //     headImg: 'iconfont icon-yiyuan2',
      //     numberColor: '#3C4C71'
      //   },
      //   yiyuanzixun: {
      //     headImg: 'iconfont icon-yiyuanzixun',
      //     numberColor: '#496DC3'
      //   },
      //   yiyuanguanjia_yinshianpai: {
      //     headImg: 'iconfont icon-ico_yiyuanguanjia_yinshianpai',
      //     numberColor: '#496DC3'
      //   }
      // }
    }
  },
  props: {
    w: {
      type: String,
      default: '110'
    },
    number: {
      type: String,
      default: '1200'
    },
    explain: {
      type: String,
      default: '用户访问量'
    },
    role: {
      validator(value) {
        return ['yiyuan', 'yiyuan1', 'yiyuan2', 'yiyuanjieshaobeifen', 'yiyuanzixun', 'yiyuanguanjia_yinshianpai'].includes(value)
      },
      default: 'yiyaun'
    }
  },
  methods: {},
  mounted() {
    this.cardStyle = `width: ${this.wh * 2.115}px; height: ${this.wh * 2 / 5 * 1.9 + 2}px;`
    this.numberColor = this.cardData[this.roleName].numberColor
    this.numberStyle = `color: ${this.numberColor};`
    this.headImg = this.cardData[this.roleName].headImg
  }
}
</script>

<style scoped>
*{
  font-size: 16px;
}
#number{
  height: 100%;
  width: 100%;
}
.main {
  position: relative;
  width: 13rem;
  height: 6rem;
  background: #f5f7f9;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 50%);
  border-radius: 10px;
}

.main:hover {
  background: rgba(255, 255, 255, 0.65);
  transform: scale(102%, 102%);
}

.head-img {
  margin-left: 20px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  float: left;
}
.head-img > img{
  height: 5rem;
  width: 5rem;
}
.text {
  width: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.number {
  display: block;
  font-size: 24px;
  color: rgba(0, 0, 0, .5);
  margin: 5px;
  font-weight: bold;
}

.explain {
  font-size: 15px;
  display: block;
  margin: 5px;
  color: rgba(0, 0, 0, .5);
}

.iconfont{
  font-size: 80px;
}
</style>
